import { sanitizeRichHtml } from "@lib/sanitizeHtml"
import * as m from "@paraglide/messages"
import type { CompanyHistoryItem } from "@site-types/content"
import { useRouteShellContext } from "@components/routeShellContext"
import { imageAlt, imageRenderProps, imageTitle, localized } from "../../componentUtils"
import OptimizedImage from "../../OptimizedImage"
import "./styles.css"

export function CompanyTimeline({
  historyItems,
}: {
  historyItems: CompanyHistoryItem[]
}) {
  const { locale } = useRouteShellContext()
  const history = localized<CompanyHistoryItem>(historyItems, locale).sort((a, b) => {
    const aTitle = a.title ?? ""
    const bTitle = b.title ?? ""
    const yearA = Number.parseInt(aTitle.slice(0, 4), 10)
    const yearB = Number.parseInt(bTitle.slice(0, 4), 10)
    const monthA = Number.parseInt(aTitle.slice(5), 10)
    const monthB = Number.parseInt(bTitle.slice(5), 10)
    if (yearA !== yearB) return yearB - yearA
    return monthB - monthA
  })

  return (
    <section
      className="timeline"
      data-id="company-timeline"
    >
      <h2>{m.company_companyHistory({}, { locale: locale })}</h2>
      <div className="history-container">
        {history.map((entry, index) => (
          <div
            className="entry"
            data-id={`company-timeline-entry-${index}`}
            key={entry.id ?? index}
          >
            <h3>{entry.year}</h3>
            <p dangerouslySetInnerHTML={{ __html: sanitizeRichHtml(entry.description) }} />
            {entry.images?.map((image, imageIndex) => {
              const renderProps = imageRenderProps(image, "logo")
              return (
                <OptimizedImage
                  key={`${entry.id ?? index}-${image.asset?.objectKey ?? image.asset?.url ?? imageIndex}`}
                  title={imageTitle(image, locale)}
                  alt={imageAlt(image, locale)}
                  {...renderProps}
                  width={renderProps.width ?? 500}
                  height={renderProps.height ?? 106}
                />
              )
            })}
          </div>
        ))}
        {history.length % 2 === 0 ? <div data-id="company-timeline-spacer" /> : null}
      </div>
    </section>
  )
}

export default CompanyTimeline
